import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, NgIf, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { ValidationService } from '../../services/validation.service';
import { ScriptService } from '../../services/script.service';
import { ToggleTabsComponent } from '../../components/toggle-tabs/toggle-tabs.component';
import { AssessmentService } from '../../services/assessment.service';
import { EvaluationService } from '../../services/evaluation.service';
import { DropdownService } from '../../services/dropdown.service';
import { GetEvaluationMarksPipe } from '../../pipes/get-evaluation-marks.pipe';
import { GracePeriodCountdownComponent } from '../../components/grace-period-countdown/grace-period-countdown.component';

@Component({
  selector: 'app-script-list-page',
  imports: [HeaderComponent, ButtonComponent, NgIf, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, FormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, ToggleTabsComponent, SelectInputComponent, GetEvaluationMarksPipe, DatePipe],
  providers: [DatePipe],
  templateUrl: './script-list-page.component.html',
  styleUrl: './script-list-page.component.css'
})
export class ScriptListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Script';
  evaluation: any = 'Start'
  evaluation_id: any
  form: FormGroup;
  params: any = {};
  selected_item: any = {};
  items: any;
  script: any;
  header_details: any = {}
  is_grace_period_active = false;

  columns: any = [];

  actions(row: any) {
    let actions: any = []

    // Check if Re-Check button should be shown based on grace period
    const showRecheckButton = this.isWithinGracePeriod(row);
    if (this.header_details.type == 'Auto') {
      if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        // For head evaluators
        if (this.current_status_filter === 'Checked' || this.current_status_filter === 'Completed') {
          // For Checked/Completed status, always show View button; Re-Check if within grace period
          if (showRecheckButton) {
            actions.push({ type: 'button', text: 'Re-Check', function: this.recheckHeadEvaluation.bind(this) })
          }
          actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
        } else if (this.current_status_filter === 'Pending') {
          if (this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
            actions.push({ type: 'button', text: 'Check', function: this.check.bind(this) })
          } else {
            actions.push({ type: 'button', text: 'Evaluate', function: this.check.bind(this) })
          }
        } else if (this.current_status_filter === 'In Progress') {
          actions.push({ type: 'button', text: 'Resume', function: this.check.bind(this) })
        }
      }
      // For regular evaluators - show Re-Check and View buttons for Completed scripts
      else {
        if (showRecheckButton) {
          actions.push({ type: 'button', text: 'Re-Check', function: this.recheck.bind(this) })
        }
        // Always show View button for completed scripts
        actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
      }
    } else if (this.header_details.type?.toLowerCase() == 'manual') {
      if (this.current_status_filter === 'Checked' || this.current_status_filter === 'Completed') {
        // Show Re-Check only if still within grace period
        if (showRecheckButton) {
          actions.push({ type: 'button', text: 'Re-Check', function: this.recheck.bind(this) })
        } else {
          actions.push({ type: 'text', text: 'Submitted', disabled: true, class: 'text-[#A3A3A3] text-[14px] font-medium' })
        }
        actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
      } else if (this.current_status_filter === 'Pending') {
        const buttonText = this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view ? 'Check' : 'Evaluate';
        actions.push({ type: 'button', text: buttonText, function: this.manual_check.bind(this) })
      } else if (this.current_status_filter === 'In Progress') {
        actions.push({ type: 'button', text: 'Resume', function: this.recheck.bind(this) })
      }
    }

    return actions
  }

  async manual_check(item: any) {
    try {
      let response = await this.es.add({ script_id: item.id });
      this.route.navigate(['/evalution'], { queryParams: { evaluation_id: response?.data?.id, evaluation_type: this.params.evaluation_type } });
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || error?.message || 'Failed to start evaluation', 'Error', 'error');
    }
  }
  async resume(item: any) {
    console.log(item.Evaluations);

    //  this.route.navigate(['/evalution'], { queryParams: { evaluation_id: response?.data?.id, } });
  }

  async check(item: any) {
    console.log('check called', item?.id);
    try {
      let response = await this.es.start_head_evaluation({ script_id: item.id });
      console.log('start_head_evaluation response', response);
      const evaluation_id = response?.data?.evaluation_id || response?.data?.id;
      if (!evaluation_id) {
        this.gs.toastr_shows_function(response?.message || 'Failed to start head evaluation', 'Error', 'error');
        return;
      }
      this.route.navigate(['/evalution'], { queryParams: { evaluation_id, evaluation_type: this.params.evaluation_type } });
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || error?.message || 'Failed to start head evaluation', 'Error', 'error');
    }
  }
  async recheckHeadEvaluation(item: any) {
    // Find HE's own head evaluation (not the evaluator's last-level which also has head_evaluation: true)
    const currentUserId = this.gs.user_data.id;
    const headEvaluation = item.Evaluations?.find((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
    if (!headEvaluation) {
      this.gs.toastr_shows_function('No head evaluation found for this script', 'Error', 'error');
      return;
    }

    this.route.navigate(['/evalution'], { queryParams: { evaluation_id: headEvaluation.id, evaluation_type: this.params.evaluation_type } });
  }
  async recheck(item: any) {
    try {
      // Get the latest evaluation (the last one in the array)
      const evaluation = item.Evaluations && item.Evaluations.length > 0
        ? item.Evaluations[item.Evaluations.length - 1]
        : null;

      if (!evaluation) {
        this.gs.toastr_shows_function('No evaluation found for this script', 'Error', 'error');
        return;
      }

      this.route.navigate(['/evalution'], { queryParams: { evaluation_id: evaluation.id, evaluation_type: this.params.evaluation_type } });
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }
  async viewScript(item: any) {
    // Navigate to evaluation page in view-only mode
    let evaluation;

    if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
      // For head evaluators, find their own head evaluation (user_id check avoids picking evaluator's last-level eval)
      const currentUserId = this.gs.user_data.id;
      evaluation = item.Evaluations?.find((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
    } else {
      // For regular evaluators, find their own latest evaluation by user_id
      const currentUserId = this.gs.user_data.id;
      const userEvals = item.Evaluations?.filter((e: any) => e.user_id === currentUserId);
      if (userEvals && userEvals.length > 0) {
        evaluation = userEvals.reduce((latest: any, current: any) =>
          new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest
        );
      }
      // Fallback: any non-head evaluation
      if (!evaluation) {
        evaluation = item.Evaluations?.find((e: any) => !e.head_evaluation || e.head_evaluation === false);
      }
    }
    console.log(item);

    if (evaluation) {
      this.route.navigate(['/evalution'], { queryParams: { evaluation_id: evaluation.id, view: true, evaluation_type: this.params.evaluation_type } });
    }
  }
  async continue(item: any) {
    this.route.navigate(['/evalution'], { queryParams: { script_id: item.id, evaluation_type: this.params.evaluation_type } });
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ss: ScriptService, public ar: ActivatedRoute, public vs: ValidationService, public es: EvaluationService, public ass: AssessmentService, public ds: DropdownService, private datePipe: DatePipe) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.location_name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['evaluator']);
    let isFirstLoad = true;
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }

      // Initialize current_status_filter from query params if present
      if (params['status']) {
        this.current_status_filter = params['status'] === 'Completed' ? 'Checked' : params['status'];
      }

      // On subsequent filter changes (items already loaded), call directly
      if (!isFirstLoad) {
        this.get_script_list(this.params);
      }
      isFirstLoad = false;
    })
    await this.get_evaluation()
    await this.get_list()

    // Set default status if not provided in query params, now that header_details.type is available
    if (!this.params['status']) {
      if (!this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        this.current_status_filter = this.header_details.type?.toLowerCase() == 'auto' ? 'Checked' : 'Pending';
      } else {
        this.current_status_filter = 'Pending';
      }
    }

    await this.initializeColumns();
    // Initial load: get_list is done, items is set, now fetch scripts
    this.get_script_list(this.params)
  }

  async initializeColumns() {
    const hasHeadPermission = this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view;

    this.columns = [
      { headerName: 'Script ID', field: 'script_id', },
      { headerName: 'Grace Period Left', filter: false, flex: 1, cellRenderer: GracePeriodCountdownComponent, cellRendererParams: { onExpired: this.onGracePeriodExpired.bind(this) } },
    ];

    // Add dynamic level columns only if user has head evaluation permission
    if (hasHeadPermission && this.items?.data) {
      const numberOfEvaluations = parseInt(this.items.data.no_of_evaluation) || 3;

      // Dynamically create L1, L2, L3... columns based on number_of_evaluations
      for (let i = 1; i <= numberOfEvaluations; i++) {
        this.columns.push({
          headerName: `L${i}`,
          filter: true,
          flex: 1,
          valueGetter: (params: any) => this.getEvaluationMarks(params.data, i)
        });
      }

      if (this.current_status_filter == 'Pending' || this.current_status_filter == 'To Do') {
        this.columns.push(
          { headerName: 'Max Marks', field: 'Assessment.total_marks', filter: false, flex: 1, },
        );
      }
      if (this.current_status_filter == 'Completed' || this.current_status_filter == 'Checked') {
        // Add Head Evaluation column
        this.columns.push({
          headerName: 'Head Evaluation',
          filter: true,
          flex: 1,
          valueGetter: (params: any) => this.getHeadEvaluationMarks(params.data)
        });
      }
      this.columns.push({ headerName: 'Time Taken', field: 'time_taken', filter: true, flex: 1, valueFormatter: (p: any) => { const v = p.value; return (!v || /^0\s*(min|mins|sec|secs)(\s+0\s*(min|mins|sec|secs))*$/i.test(String(v).trim())) ? '-' : v; } });

      this.columns.push({
        headerName: 'Evaluated On',
        filter: true,
        flex: 1,
        field: 'updatedAt',
        valueFormatter: (params: any) => {
          if (this.current_status_filter === 'Pending' && this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) return '-';
          const dateVal = params.value || params.data?.updatedAt;
          return dateVal ? this.datePipe.transform(dateVal, 'dd-MM-yyyy') : '-';
        }
      });
    } else {
      // Add only Marks column for non-head users - show any available evaluation marks
      this.columns.push({
        headerName: 'Obtained Marks',
        filter: true,
        flex: 1,
        valueGetter: (params: any) => this.getAnyEvaluationMarks(params.data)
      });
      this.columns.push({ headerName: 'Time Taken', field: 'time_taken', filter: true, flex: 1, valueFormatter: (p: any) => { const v = p.value; return (!v || /^0\s*(min|mins|sec|secs)(\s+0\s*(min|mins|sec|secs))*$/i.test(String(v).trim())) ? '-' : v; } });
      this.columns.push({
        headerName: 'Evaluated On',
        filter: true,
        flex: 1,
        field: 'updatedAt',
        valueFormatter: (params: any) => {
          if (this.header_details.type == 'Manual') {
            if (this.current_status_filter === 'Pending' || this.current_status_filter === 'In Progress') return '-';
          }
          const dateVal = params.value || params.data?.updatedAt;
          return dateVal ? this.datePipe.transform(dateVal, 'dd-MM-yyyy') : '-';
        }
      });
    }
    // Add Actions column for both head evaluators and regular evaluators
    this.columns.push({ headerName: "Actions", sortable: false, filter: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellStyle: { 'justify-content': 'center' }, cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 180, minWidth: 180, maxWidth: 180 });

  }

  tabList: { name: string, label?: string, action: () => void }[] = [
    { name: 'Pending', action: () => this.filter('To Do') },
    { name: 'In Progress', action: () => this.filter('IN-PROGRESS') },
    { name: 'Submitted', action: () => this.filter('SUBMITTED') },
  ];
  current_status_filter = 'Pending';
  redirect_button_text = 'Check'
  selected_faculty_id: any;
  filtered_faculty_list: any[] = [];
  view_scripts_filter: string = 'All Scripts'; // For View Scripts dropdown
  script_counts: any = { pending: 0, in_progress: 0, checked: 0 };

  // Getter to map current_status_filter to tab name
  get activeTabName(): string {
    const statusMap: { [key: string]: string } = {
      'Pending': 'Pending',
      'To Do': 'Pending',
      'In Progress': 'In Progress',
      'IN-PROGRESS': 'In Progress',
      'In-Progress': 'In Progress',
      'Checked': 'Completed',
      'Completed': 'Completed',
      'SUBMITTED': 'Submitted'
    };
    return statusMap[this.current_status_filter] || 'Pending';
  }

  filter(type: string) {
    this.current_status_filter = type;
    if (type == 'Pending' || type == 'To Do') {
      this.redirect_button_text = 'Check'
    } else if (type == 'In Progress' || type == 'IN-PROGRESS') {
      this.redirect_button_text = 'Resume'
    } else if (type == 'Checked') {
      this.redirect_button_text = 'View'
    } else {
      this.redirect_button_text = 'Re-Check'
    }
    this.initializeColumns();
    // Update params object and query params to keep them in sync
    this.params = {
      ...this.params,
      status: type,
      page: 1
    };
    this.route.navigate([], {
      queryParams: this.params,
      queryParamsHandling: 'merge'
    });
  }

  onViewScriptsChange(value: string) {
    this.view_scripts_filter = value;
    this.get_script_list({ page: 1 });
  }

  onFacultyChange(event: any) {
    this.selected_faculty_id = event.value ? event.value.value : null;
    this.params = {
      ...this.params,
      user_id: this.selected_faculty_id
    }
    this.get_list(this.params);
    this.get_script_list({ page: 1 });
  }


  async get_evaluation() {
    try {
      let params: any = {}
      params = {
        assessment_id: this.params.assessment_id,
        user_id: this.gs.user_data.id
      }
      console.log(params, 'params');
      const res = await this.es.get_my_evaluation(params);
      if (res.message == 'No evaluation found for this assessment') {
        this.evaluation = 'Start'
      } else if (res.data) {
        this.evaluation = 'Resume'
        this.evaluation_id = res.data.evaluation_id
      }
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  async redirect_to_evaluation_page() {
    try {
      let params: any = {}
      params = {
        assessment_id: +this.params.assessment_id,
        user_id: this.gs.user_data.id,
        level: 1,
      }
      if (this.evaluation == 'Resume') {
        this.route.navigate(['/evalution'], { queryParams: { evaluation_id: this.evaluation_id, evaluation_type: this.params.evaluation_type }, });
      } else if (this.evaluation == 'Start') {
        const res = await this.es.start_ramdom_evaluation(params);
        if (!res.data) {
          this.gs.toastr_shows_function(res.message, 'Warning', 'warning');
          return;
        }
        if (res.data.evaluation_id) {
          this.route.navigate(['/evalution'], { queryParams: { evaluation_id: res.data?.evaluation_id, evaluation_type: this.params.evaluation_type }, });
        } else {
          this.gs.toastr_shows_function(res.message, 'Error', 'error');
        }
      }
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
      console.error("Error fetching Booking list:", error);
    }
  }

  async get_list(filter?: any) {
    try {
      const res = await this.ass.get(this.params.assessment_id, { count: true, evaluation_type: this.params.evaluation_type });
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      // Load evaluators filtered by subject_id from assessment
      const subject_id = res.data?.subject_id || res.data?.Subject?.id;
      if (subject_id && this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        this.filtered_faculty_list = await this.ds.get_evaluators_by_subject(subject_id);
      }

      this.header_details.evaluated = res.data.evaluated_script
      this.header_details.total = res.data.total_script
      this.header_details.pending = res.data.pending_script
      this.header_details.checked = res.data.checked_scripts
      this.header_details.he_pending_scripts = res.data.he_pending_scripts
      this.header_details.checked_scripts = res.data.checked_scripts
      this.header_details.he_in_progress_scripts = res.data.he_in_progress_scripts
      this.header_details.type = res.data.type;
      this.header_details.in_progress_script = res.data.in_progress_script
      this.items = res;
      this.is_grace_period_active = false; // computed per-script in get_script_list

      if (this.gs.user_role_data.evaluations_and_revaluations_head_evaluation_view) {
        this.tabList = [
          { name: 'Pending', label: `Available (${this.header_details?.he_pending_scripts || 0})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.he_in_progress_scripts || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED  (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      } else {
        this.tabList = [
          { name: 'Pending', label: `Available (${this.header_details?.pending || 0})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.in_progress_script || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      }
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async get_script_list(filter?: any) {
    try {
      // Map 'Checked' status to 'Completed' for backend API
      const statusForBackend = this.current_status_filter === 'Checked' ? 'Completed' : this.current_status_filter;

      const params: any = { assessment_id: this.params.assessment_id, ...filter, status: statusForBackend, dashboard: true, search: this.params.search };
      if (this.selected_faculty_id) {
        params['user_id'] = this.selected_faculty_id;
      }

      // For Head Evaluators, send is_grace_period_active as false
      if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        params['is_grace_period_active'] = false;
      }

      // Add filter for Rechecked Scripts
      if (this.view_scripts_filter === 'Rechecked Scripts') {
        params['rechecked'] = true;
      }

      const res: any = await this.ss.get_list(params);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      const isHE = this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view;
      const isManual = this.header_details.type?.toLowerCase() === 'manual';
      const gracePeriod = this.items?.data?.grace_period;
      let gracePeriodMs = 0;
      if (gracePeriod) {
        const [hours, minutes, seconds] = gracePeriod.split(':').map(Number);
        gracePeriodMs = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
      }

      // Pre-format static grace period label (HH:MM:SS → MM:SS or HH:MM:SS)
      let gracePeriodStaticLabel = '';
      if (gracePeriodMs > 0) {
        const [gpH, gpM, gpS] = (gracePeriod || '00:00:00').split(':').map(Number);
        if (gpH > 0) {
          gracePeriodStaticLabel = gpM > 0 ? `${gpH} Hours ${gpM} Mins` : `${gpH} Hours`;
        } else if (gpM > 0) {
          gracePeriodStaticLabel = `${gpM} Mins ${gpS} Secs`;
        } else {
          gracePeriodStaticLabel = `-`;
        }
      }

      const isToDoOrInProgress = this.current_status_filter !== 'Checked';

      // Add Sr.No and grace_period_end_time to each item
      res.data = (res.data || []).map((item: any, index: number) => {
        let gracePeriodEndTime = 0;       // for countdown display
        let gracePeriodFilterEndTime = 0; // for HE filter (evaluator's grace period)
        // Static value shown in To Do/In Progress for Manual (both roles) or Auto (HE only)
        const grace_period_display = (gracePeriodMs > 0 && isToDoOrInProgress && (isManual || isHE))
          ? gracePeriodStaticLabel : '';

        if (gracePeriodMs > 0) {
          if (isHE) {
            const he_user_id = this.gs.user_data.id;

            // Filter value: evaluator's (non-HE) latest evaluation — used to hide script from HE while evaluator grace period is active
            const non_he_evals = item.Evaluations?.filter((e: any) => e.user_id !== he_user_id && !e.head_evaluation);
            if (non_he_evals && non_he_evals.length > 0) {
              const latest_non_he_eval = non_he_evals.sort((a: any, b: any) => b.level - a.level)[0];
              const base_time = latest_non_he_eval?.submitted_at ? new Date(latest_non_he_eval.submitted_at).getTime() : 0;
              if (base_time) gracePeriodFilterEndTime = base_time + gracePeriodMs;
            }

            // Display value (Checked tab only): HE's own head evaluation submitted_at
            if (this.current_status_filter === 'Checked') {
              const he_eval = item.Evaluations?.find((e: any) => e.head_evaluation === true && e.user_id === he_user_id);
              if (he_eval) {
                const base_time = he_eval.submitted_at ? new Date(he_eval.submitted_at).getTime() : 0;
                if (base_time) gracePeriodEndTime = base_time + gracePeriodMs;
              }
            }
          } else {
            // For regular evaluators: show timer in all tabs (auto) or only Checked tab (manual)
            const show_timer = isManual ? (this.current_status_filter === 'Checked') : true;
            if (show_timer) {
              const current_user_id = this.gs.user_data.id;
              // Exclude draft evaluations — grace period should only start after submission
              const user_evaluations = item.Evaluations?.filter((e: any) => e.user_id === current_user_id && !e.is_draft);
              if (user_evaluations && user_evaluations.length > 0) {
                const latest_eval = user_evaluations.sort((a: any, b: any) => b.level - a.level)[0];
                const base_time = latest_eval?.submitted_at ? new Date(latest_eval.submitted_at).getTime() : 0;
                if (base_time) gracePeriodEndTime = base_time + gracePeriodMs;
              }
            }
          }
        }

        return {
          ...item,
          SrNo: startindex + index + 1,
          grace_period_end_time: gracePeriodEndTime,
          grace_period_filter_end_time: gracePeriodFilterEndTime,
          grace_period_display
        };
      });

      // For HE: filter out scripts where evaluator's grace period is still active (only for To Do / In Progress)
      if (isHE && gracePeriodMs > 0 && this.current_status_filter !== 'Checked') {
        const now = Date.now();
        const visibleScripts = res.data.filter((item: any) =>
          item.grace_period_filter_end_time === 0 || now > item.grace_period_filter_end_time
        );
        this.is_grace_period_active = visibleScripts.length === 0 && res.data.length > 0;
        res.data = visibleScripts.map((item: any, index: number) => ({ ...item, SrNo: startindex + index + 1 }));
      } else {
        this.is_grace_period_active = false;
      }

      this.script = res;

      // Prefer structured counts from API (res.counts). Support multiple shapes and fallbacks.
      const c = res.counts || {};
      const pendingFromApi = c.todo ?? c.pending ?? c['to_do'] ?? res.pending_count ?? 0;
      const inProgressFromApi = c.in_progress ?? c.inprogress ?? c['in-progress'] ?? res.in_progress_count ?? 0;
      const checkedFromApi = c.checked ?? c.completed ?? res.checked_count ?? 0;

      // Initialize script_counts from available API fields
      this.script_counts = {
        pending: pendingFromApi || 0,
        in_progress: inProgressFromApi || 0,
        checked: checkedFromApi || 0
      };

      // If assessment API already returned counts earlier (this.items.data), prefer those values
      // this.items is loaded by get_list() and contains total_script, pending_script, evaluated_script, checked_scripts
      if (this.items?.data) {
        const ad = this.items.data;
        this.script_counts = {
          pending: (ad.pending_script ?? this.script_counts.pending),
          // in_progress = evaluated - checked (if that represents scripts currently in progress)
          in_progress: Math.max(0, ((ad.evaluated_script ?? 0) - (ad.checked_scripts ?? 0))),
          checked: (ad.checked_scripts ?? this.script_counts.checked)
        };
      }

      // If API returned a single "count" for this filtered request (res.count), map it to requested status
      if (typeof res.count === 'number') {
        const req = (statusForBackend || '').toString().toLowerCase();
        if (req === 'completed' || req === 'checked') {
          this.script_counts.checked = res.count;
        } else if (req === 'pending' || req === 'to do' || req === 'todo') {
          this.script_counts.pending = res.count;
        } else if (req.includes('progress')) {
          this.script_counts.in_progress = res.count;
        } else {
          this.script_counts.checked = res.count;
        }
      }

      // Build tabList labels with counts
      if (this.gs.user_role_data.evaluations_and_revaluations_head_evaluation_view) {
        this.tabList = [
          { name: 'Pending', label: `Available (${this.header_details?.he_pending_scripts || 0})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.he_in_progress_scripts || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      } else {
        this.tabList = [
          { name: 'Pending', label: `Available (${this.header_details?.pending || 0})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.in_progress_script || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      }
    } catch (error: any) {
      console.error("Error fetching scripts list:", error);
    }
  }

  getEvaluationMarks(script: any, level: number): string {
    if (!script || !script.Evaluations || !Array.isArray(script.Evaluations)) {
      return '-';
    }

    const evaluation = script.Evaluations.find((e: any) => e.level === level);

    if (!evaluation) {
      return '-';
    }

    return evaluation.total_marks?.toString() || '-';
  }

  getAnyEvaluationMarks(script: any): string {
    if (!script || !script.Evaluations || !Array.isArray(script.Evaluations) || script.Evaluations.length === 0) {
      return '-';
    }

    // Get the latest evaluation (highest level) or first available
    const latestEvaluation = script.Evaluations.reduce((latest: any, current: any) => {
      return (current.level > latest.level) ? current : latest;
    }, script.Evaluations[0]);

    return latestEvaluation?.total_marks?.toString() || '-';
  }

  getHeadEvaluationMarks(script: any): string {
    if (!script || !script.Evaluations || !Array.isArray(script.Evaluations)) {
      return '-';
    }

    const currentUserId = this.gs.user_data.id;
    const headEvaluation = script.Evaluations.find((e: any) => e.head_evaluation === true && e.user_id === currentUserId);

    if (!headEvaluation) {
      return '-';
    }

    return headEvaluation.total_marks?.toString() || '-';
  }

  isWithinGracePeriod(script: any): boolean {
    if (!script) return false;

    if (script.grace_period_expiry) {
      return Date.now() < new Date(script.grace_period_expiry).getTime();
    }

    if (!script.Evaluations || !this.items?.data) {
      return false;
    }

    const gracePeriod = this.items.data.grace_period;
    if (!gracePeriod) {
      return false;
    }

    const [hours, minutes, seconds] = gracePeriod.split(':').map(Number);
    const gracePeriodMs = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;

    let relevantEvaluation;

    if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
      // For HE re-check: check their own head evaluation's createdAt (user_id check avoids picking evaluator's last-level eval)
      const currentUserId = this.gs.user_data.id;
      relevantEvaluation = script.Evaluations.find((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
    } else {
      // For regular evaluator re-check: their own latest submitted (non-draft) evaluation's createdAt
      const currentUserId = this.gs.user_data.id;
      const userEvaluations = script.Evaluations.filter((e: any) => e.user_id === currentUserId && !e.is_draft);
      if (userEvaluations.length > 0) {
        relevantEvaluation = userEvaluations.reduce((latest: any, current: any) =>
          new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest
        );
      }
    }

    if (!relevantEvaluation) {
      return false;
    }

    const baseTime = relevantEvaluation.submitted_at ? new Date(relevantEvaluation.submitted_at).getTime() : 0;
    if (!baseTime) return false;

    return (Date.now() - baseTime) <= gracePeriodMs;
  }

  onGracePeriodExpired(params: any) {
    if (params && params.api && params.node) {
      setTimeout(() => {
        params.api.refreshCells({ rowNodes: [params.node], force: true });
      }, 0);
    }
  }
}
